import React, { useEffect, useMemo } from 'react';
import API from '../../../veracityapi';
import moment from 'moment';
import Loader from 'SharedComponents/Loader/Loader';

const PartnerComponent = (params) => {
	const [isPartnerLoading, setIsPartnerLoading] = React.useState(true);
	const partnerName = params.name;
	const titleName = params.titleCompany;

	const partnerGUID = params.guid;
	const websitesEndpointAddr = `/partner/website/${partnerGUID}`;
	const PartnersEndpointAddr = `/partner/subpartners/${partnerGUID}`;
	const OwnWebsitesEndpointAddr = `/partner/own/${partnerGUID}`;
	const OwnLinksEndpointAddr = `/partner/own/${partnerGUID}/links`;

	const [payloadOwnWebsite, setPayloadOwnWebsite] = React.useState(false);
	const [payloadOwnLinks, setPayloadOwnLinks] = React.useState(false);
	const [payloadWebsites, setPayloadWebsites] = React.useState(false);
	const [payloadPartners, setPayloadPartners] = React.useState(false);
	const [subPartnerElements, setSubPartnerElements] = React.useState({});
	const [state, changeState] = React.useState(0);

	useEffect(() => {
		const awaiting = [];
		if (!payloadOwnLinks) {
			awaiting.push(API.GET(OwnLinksEndpointAddr).then((response) => {
				console.log(response);
				setPayloadOwnLinks(response);
			}).catch((error) => {
				console.error('Error fetching data:', error);
			}));
		}
		if (!payloadWebsites) {
			awaiting.push(API.GET(websitesEndpointAddr).then((response) => {
				setPayloadWebsites(response);
			}).catch((error) => {
				console.error('Error fetching data:', error);
			}));
		}
		if (!payloadPartners) {
			awaiting.push(API.GET(PartnersEndpointAddr).then((response) => {
				setPayloadPartners(response);
			}).catch((error) => {
				console.error('Error fetching data:', error);
			}));
		}
		if (!payloadOwnWebsite) {
			awaiting.push(API.GET(OwnWebsitesEndpointAddr).then((response) => {
				setPayloadOwnWebsite(response);
			}).catch((error) => {
				console.error('Error fetching data:', error);
			}));
		}
		Promise.all(awaiting).then(() => {
			setIsPartnerLoading(false);
			updateState();
		});
	}, []);

	const utcTimeStringToLocalTimeString = (utcTimeString, inFormat = "", outFormat = "YYYY-MM-DD") => {
		const timeZone = localStorage.getItem('timezone') || 'UTC';
		return moment.utc(utcTimeString, inFormat).tz(timeZone).format(outFormat);
	};

	const isSubPartnerActive = (guid) => {
		return (typeof subPartnerElements[guid] !== "undefined");
	}

	const updateState = () => {
		if (typeof params.changeState === "undefined") {
			changeState(state + 1);
		} else {
			params.changeState();
		}
	}

	const toggleSubPartner = (evt) => {
		const partnerGUID = evt.target.getAttribute('data-partner-guid');
		const partnerName = evt.target.getAttribute('data-partner-name');
		const partnerElements = subPartnerElements;
		if (isSubPartnerActive(partnerGUID)) {
			delete partnerElements[partnerGUID];
		} else {
			partnerElements[partnerGUID] = <PartnerComponent guid={partnerGUID} name={partnerName} titleCompany={partnerName} changeState={() => { updateState(); }} />;
		}
		setSubPartnerElements(partnerElements);
		updateState();
	}

	const renderWebsiteList = (websites) => {
		const tableData = [];

		if (websites.items.length === 0) {
			return (<span className='no-data'>You have no end user websites.</span>);
		}

		for (const item of websites.items) {
			tableData.push({
				"website_name": item.website_name,
				"license_type": item.type,
				"license_key": item.licence_key,
				"expires": item.end_date,
				"afp": item.afp_status
			});
		}

		return (
			<table>
				<thead>
					<tr>
						<th>Website Name</th>
						<th>License Type</th>
						<th>License Key</th>
						<th>License Expiry</th>
						<th>Ad Fraud Status</th>
					</tr>
				</thead>
				<tbody>
					{tableData.map((row, index) => (
						<tr key={index}>
							<td>{row.website_name}</td>
							<td>{row.license_type}</td>
							<td>{row.license_key}</td>
							<td>{row.expires==="Ongoing"? "Never":utcTimeStringToLocalTimeString(row.expires,"","Do MMMM YYYY")}</td>
							<td>{row.afp}</td>
						</tr>
					))}
				</tbody>
			</table>
		);
	}

	const renderPartnerList = () => {
		const tableData = [];

		if (payloadPartners.items.length === 0) {
			return (<span className='no-data'>You have no resellers.</span>);
		}

		for (const item of payloadPartners.items) {
			tableData.push({
				"name": item.name,
				"partner_guid": item.guid,
				"partner_url": `https://static.platform.veracitytrustnetwork.com/${item.url_key}/partner-registration`,
				"customer_url": `https://static.platform.veracitytrustnetwork.com/${item.url_key}/platform-registration`
			});
		}

		return (
			<table key={state}>
				<thead>
					<tr className='partnerGrid'>
						<th>Partner Name</th>
						<th>Partner GUID</th>
						<th>See More</th>
					</tr>
				</thead>
				<tbody>
					{tableData.map((row, index) => (
						<>
							<tr key={index} className='partnerGrid'>
								<td>{row.name}</td>
								<td>{row.partner_guid}</td>
								<td>
									<span className='button' onClick={toggleSubPartner} data-partner-guid={row.partner_guid} data-partner-name={row.name} dangerouslySetInnerHTML={{__html:!isSubPartnerActive(row.partner_guid) ? "Show &hkswarow;" : "Hide &nwarhk;"}}>
									</span>
								</td>
							</tr>
							{isSubPartnerActive(row.partner_guid) &&
								<tr key={"sub_partner_" + index}>
									<td colSpan="4">
										{subPartnerElements[row.partner_guid]}
									</td>
								</tr>
							}
						</>
					))}
				</tbody>
			</table>
		);
	}

	return useMemo(() => {
		if (isPartnerLoading) {
			return (<div class="loading">
				<Loader />
				<span class="text">Loading {titleName === "Your" ? titleName : titleName + "'s"} Partner data...</span>
			</div>);
		}
		return (
			<div className='partnerPage' key={state}>
				<h1>{titleName === "Your" ? partnerName + "'s" : titleName + "'s"} Partner Management</h1>
				<div className='Own'>
					<h2>{titleName === "Your" ? titleName : titleName + "'s"}  links</h2>
					<p>Customer: <a href={`https://static.platform.veracitytrustnetwork.com/${payloadOwnLinks.item.url_key}/platform-registration`}>{`https://static.platform.veracitytrustnetwork.com/${payloadOwnLinks.item.url_key}/platform-registration`}</a></p>
					<p>Partner: <a href={`https://static.platform.veracitytrustnetwork.com/${payloadOwnLinks.item.url_key}/partner-registration`}>{`https://static.platform.veracitytrustnetwork.com/${payloadOwnLinks.item.url_key}/partner-registration`}</a></p>
					<h2>{titleName === "Your" ? titleName : titleName + "'s"} Websites</h2>
					{renderWebsiteList(payloadOwnWebsite)}
				</div>
				<div className='Customers'>
					<h2>{titleName === "Your" ? titleName : titleName + "'s"} End User Websites</h2>
					{renderWebsiteList(payloadWebsites)}
				</div>
				<div className='Resellers'>
					<h2>{titleName === "Your" ? titleName : titleName + "'s"} Resellers</h2>
					{renderPartnerList(payloadPartners)}
				</div>
			</div>
		);
	}, [isPartnerLoading, state]);
};

export default PartnerComponent;